var map = {
	"./advanced-fee-img.png": 224,
	"./fake-guru-img.png": 230,
	"./knight-384-outline-gray.png": 805,
	"./knight-384-outline.png": 844,
	"./knight.png": 559,
	"./mlm-img.png": 981,
	"./refund-scam-img.png": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;